import React from 'react';

export default function DesempenhoIndicadoresPage() {
  return (
    <div>
      Qualidade - Relatório de Desempenho dos Indicadores (placeholder).
    </div>
  );
}

